export var DocumentAssistantChatErrorSubcodes;
(function (DocumentAssistantChatErrorSubcodes) {
    DocumentAssistantChatErrorSubcodes["NoCredit"] = "ERROR_INSUFFICIENT_CREDITS";
})(DocumentAssistantChatErrorSubcodes || (DocumentAssistantChatErrorSubcodes = {}));
